import { render, staticRenderFns } from "./OfferCreation.vue?vue&type=template&id=38038679&scoped=true&"
import script from "./OfferCreation.vue?vue&type=script&lang=ts&"
export * from "./OfferCreation.vue?vue&type=script&lang=ts&"
import style0 from "./OfferCreation.vue?vue&type=style&index=0&id=38038679&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38038679",
  null
  
)

export default component.exports